function return_delivery_date(days) {
  const lang = document.documentElement.lang;
  if( lang == "he"){
  var monthNames = [
    "בינואר",
    "בפברואר",
    "במרץ",
    "באפריל",
    "במאי",
    "ביוני",
    "ביולי",
    "באוגוסט",
    "בספטמבר",
    "באוקטובר",
    "בנובמבר",
    "בדצמבר"
  ];
  }else{
    var monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
  }
  var today = new Date(); // Get today's date
  // Calculate the delivery start date
  var delivery_start_date = new Date(today);
  delivery_start_date.setDate(today.getDate() + days);
  // Calculate the delivery end date (start date + 1 day)
  var delivery_end_date = new Date(delivery_start_date);
  delivery_end_date.setDate(delivery_start_date.getDate() + 1);
  // Get day and month parts for formatting
  var delivery_start_day = delivery_start_date.getDate();
  // Get month index (0-11) and use it for monthNames array
  var delivery_start_month = monthNames[delivery_start_date.getMonth()];
  var delivery_end_day = delivery_end_date.getDate();
  var delivery_end_month = monthNames[delivery_end_date.getMonth()];
  // Format the output string
  var delivery_date_text;
  // Check if the start and end dates fall in the same month
  if (delivery_start_month === delivery_end_month) {
    // Same month: Format as "Month Day-Day" (e.g., "Mai 10-11")
    if( lang == "he"){
      return `${delivery_start_day}-${delivery_end_day} ${delivery_start_month}`;
    }else{
      return `${delivery_start_month} ${delivery_start_day}-${delivery_end_day}`;
    }
    
  } else {
    // Different months: Format as "Month Day - Month Day" (e.g., "Apr 30 - Mai 1")
    if( lang == "he"){
      return `${delivery_start_day} ${delivery_start_month} - ${delivery_end_day} ${delivery_end_month}`;
    }else{
      return `${delivery_start_month} ${delivery_start_day} - ${delivery_end_month} ${delivery_end_day}`;
    }    
  }
}
function update_shipping_delivery_for_products() {
  $(".pro-card-date").each(function () {
    var $element = $(this); // Get the current jQuery element
    var offset_days = $element.data("days"); // Read the data-days attribute
    if (
      offset_days !== undefined &&
      offset_days !== null &&
      offset_days !== ""
    ) {
      var offset_days_int = parseInt(offset_days, 10);
      if (!isNaN(offset_days_int)) {
        delivery_date_text = return_delivery_date(offset_days_int);
        $element.text(delivery_date_text).addClass("ADDED");
      } else {
        $element
          .text("please use an integer for the shipping days value")
          .addClass("aaaaaaaaaaa");
      }
    } else {
      $element.text("TBD").addClass("bbbbbbbbb");
    }
  });
}
function updateActiveBulkBox(quantity) {
  const qty = parseInt(quantity, 10) || 0;
  const $bulkContainer = $(".bulk-option-box");
  $bulkContainer.find(".bulk-box").removeClass("active");
  if (qty === 1) {
    $bulkContainer.find(".bulk-box.sample-order").addClass("active");
    //console.log('Sample order box activated.'); // For debugging
    const bulkPrice = $bulkContainer
      .find(".bulk-box.sample-order")
      .data("bulk-option-value");
    const subtotal = (bulkPrice * qty).toFixed(2);
    update_subtotal(subtotal, true);
    return;
  }
  if (qty > 1) {
    let foundMatch = false;
    $bulkContainer.find(".bulk-box:not(.sample-order)").each(function () {
      if (foundMatch) {
        return;
      }
      const $box = $(this);
      const minValStr = $box.data("min-val");
      const maxValStr = $box.data("max-val");
      if (minValStr !== undefined && maxValStr !== undefined) {
        const minVal = parseInt(minValStr, 10);
        const maxVal = parseInt(maxValStr, 10);
        if (!isNaN(minVal) && !isNaN(maxVal)) {
          if (qty >= minVal && qty <= maxVal) {
            $box.addClass("active");
            //console.log(`Activating box for range: ${minVal}-${maxVal}`); // For debugging
            foundMatch = true;

            const bulkPrice = $box.data("bulk-option-value");
            const subtotal = (bulkPrice * qty).toFixed(2);
            update_subtotal(subtotal);
          }
        } else {
          console.warn("Invalid data-min-val or data-max-val found on:", $box); // For debugging
        }
      } else {
        console.warn("Missing data-min-val or data-max-val found on:", $box); // For debugging
      }
    });
    if (!foundMatch) {
      console.log("No bulk range matched the quantity:", qty); // For debugging
    }
  } else {
    console.log("Quantity is less than 1, no box activated."); // For debugging
    jQuery(".bulk-option-box .bulk-box").removeClass("active");
    jQuery(".bulk-option-box .sample-order").addClass("active");
  }
}

function update_subtotal(bulkPrice, skipCurrencyConversion = false) {
  let convertedStartPrice = bulkPrice;
  console.log(bulkPrice);
  if (!skipCurrencyConversion) {
    if (currencySymbol == "$") {
      const conversionRate = window.ILS_TO_USD_RATE;
      convertedStartPrice = (bulkPrice * conversionRate).toFixed(2);
    }
  }
  const subtotal = `<h3 class="money-subtotal" data-price="${convertedStartPrice}" data-currency="${currencySymbol}">${currencySymbol} ${convertedStartPrice}</h3>`;
  $(".productView-subtotal").html(subtotal);
}

function update_product_grid_price(lang) {
  //setTimeout(function(){
  $(".product-item").each(function () {
    var productCard = $(this);
    var priceCurrentCurrency = productCard.data('price-current-currency');
    if (priceCurrentCurrency === window.currencySymbol) return;
    var priceElem = productCard.find(".pro-card-price");
    var startPrice = productCard.find(".pro-card-price").data("start-price");
    var endPrice = productCard.find(".pro-card-price").data("end-price");
    //console.log(startPrice,endPrice);
    //const currentLang = document.documentElement.lang || "he";
    const currentCurrency = $(".ts-currency__name").html();
    let convertedStartPrice = startPrice;
    let convertedEndPrice = endPrice;
    let currencySymbol = "₪";
    if (window.currencySymbol && window.currencySymbol !== '₪') {
      //console.log("working fine!");
      const conversionRate = window.ILS_TO_USD_RATE;
      convertedStartPrice = (startPrice * conversionRate).toFixed(2);
      convertedEndPrice = (endPrice * conversionRate).toFixed(2);
      currencySymbol = "$";
      // priceElem.textContent = `${convertedStartPrice} - ${convertedEndPrice} ${currencySymbol}`;
      if( lang == "he"){
        productCard.find(".pro-card-price").html(`<span class="price-value-container" style="direction: ltr;unicode-bidi: isolate-override;order:2">
                    <span class="startPrice" data-val="${startPrice}"><code style="font-size:1em;color:#000">${convertedStartPrice}</code></span>
                    <span class="priceSeparator"> &ndash; </span>
                    <span class="endPrice" data-val="${endPrice}"><code style="font-size:1em;color:#000">${convertedEndPrice}</code></span>
                </span>
                <span class="currencySymbol">${currencySymbol}</span>`);                        
      }else{
         productCard.find(".pro-card-price").html(`<span class="price-value-container" style="direction: ltr;unicode-bidi: isolate-override;order:2">
                    <span class="startPrice" data-val="${startPrice}"><code style="font-size:1em;color:#000">${convertedStartPrice}</code></span>
                    <span class="priceSeparator"> &ndash; </span>
                    <span class="endPrice" data-val="${endPrice}"><code style="font-size:1em;color:#000">${convertedEndPrice}</code></span>
                </span>
                <span class="currencySymbol">${currencySymbol}</span>`);
      }
      
    }
    productCard.data('price-current-currency', window.currencySymbol);
  });
  //}, 300);
}
function forceIntegerQTY(){
  // Select all quantity inputs on the page
  const quantityInputs = document.querySelectorAll('.quantity__input');

  // Function to strip non-integer characters
  function enforceInteger(event) {
    // Replace any character that is not a digit with an empty string
    this.value = this.value.replace(/[^0-9]/g, '');
  }

  // Add an event listener to each input
  quantityInputs.forEach(input => {
    // 'input' event fires immediately after the value has changed
    input.addEventListener('input', enforceInteger);
  });
}
$(document).ready(function () {
  let timesCalled = 0;
  const maxCalls = 100;
  const delay = 1000;
  const lang = document.documentElement.lang;
  const updateInterval = setInterval(function () {
    if (timesCalled < maxCalls) {
      update_shipping_delivery_for_products();
      //update_product_grid_price(lang);
    } else {
      console.log(`Finished calling updates ${maxCalls} times.`);
      clearInterval(updateInterval);
    }
  }, delay);
  forceIntegerQTY();
});


$(document).ready(function () {

  $(document).on('click', '.product_card_JDMreview', function(event) { 
      console.log("Link was clicked. If it doesn't navigate, something is preventing it.");
  });
  $(document).on('click', '.jdgm-preview-badge--with-link', function(event) { 
      console.log("Link was clicked22222222222");
  });
   

   
  jQuery(".colorPickerIcon").click(function () {
    jQuery("#themecolor").click();
  });
  $("#newsletter-success-modal .close-modal").click(function (e) {
    $("#newsletter-success-modal").hide();
  });
  //#####################################################
  // --- Stage 1: Find the Parent Container ---
  const productItem = document.querySelector(".halo-block-content");
  let parentNodeToObserve = null; // This is the '.card-information' div

  if (productItem) {
    parentNodeToObserve = productItem.querySelector(".card-information");
    if (!parentNodeToObserve) {
      console.error(
        "Found product item, but could not find .card-information inside it."
      );
    }
  } else {
    console.log(
      "Could not find the product item container"
    );
  }

  // --- Stage 2 Observer (Watches *inside* .delivery-details once found) ---

  // Callback function for mutations *inside* .delivery-details
  const handleDetailsMutations = (mutationsList, observer) => {
    //console.log("Mutation detected INSIDE the dynamically added .delivery-details!");

    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        //console.log(" -> Change type: Child node(s) added/removed inside .delivery-details.");
        mutation.addedNodes.forEach((node) => {
          if (
            node.nodeType === Node.ELEMENT_NODE &&
            node.classList.contains("pro-card-date")
          ) {
            console.log('    --> ".pro-card-date" span was added!');
            console.log("        Span data-days:", node.dataset.days);
            // --- Add your custom logic here for when the span appears ---
            // Example: Update UI, trigger analytics, etc.
          }
          // Add more checks here if other elements inside .delivery-details are relevant
        });
      } else if (mutation.type === "attributes") {
        console.log(
          ` -> Change type: Attribute "${mutation.attributeName}" modified on:`,
          mutation.target
        );
        if (
          mutation.target.classList.contains("pro-card-date") &&
          mutation.attributeName === "data-days"
        ) {
          console.log(
            "    --> data-days on .pro-card-date changed to:",
            mutation.target.dataset.days
          );
        }
      } else if (mutation.type === "characterData") {
        console.log(
          " -> Change type: Text content changed within:",
          mutation.target.parentNode
        );
        if (mutation.target.parentNode.classList.contains("pro-card-date")) {
          console.log("    --> Text inside .pro-card-date updated!");
        }
      }
    }
  };

  // Configuration for observing *inside* .delivery-details
  const detailsObserverConfig = {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true,
  };

  // Create the observer instance for .delivery-details (but don't start it yet)
  const detailsObserver = new MutationObserver(handleDetailsMutations);

  // --- Stage 1 Observer (Watches .card-information for .delivery-details addition) ---

  // Callback function for mutations inside .card-information
  const handleParentMutations = (mutationsList, observer) => {
    console.log(
      "Mutation detected inside .card-information (parent). Checking for .delivery-details..."
    );
    let deliveryDetailsNode = null;

    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        // Check all added nodes in this mutation
        for (const addedNode of mutation.addedNodes) {
          if (
            addedNode.nodeType === Node.ELEMENT_NODE &&
            addedNode.classList.contains("delivery-details")
          ) {
            console.log("--> SUCCESS: .delivery-details div was added!");
            deliveryDetailsNode = addedNode; // Found it!
            break; // Stop checking nodes in this mutation
          }
        }
      }
      if (deliveryDetailsNode) break; // Stop checking other mutations if found
    }

    // If .delivery-details was found in this batch of mutations:
    if (deliveryDetailsNode) {
      console.log("Disconnecting observer for .card-information (parent).");
      observer.disconnect(); // Stop watching the parent node

      // --- ACTION: .delivery-details is now present ---
      // You can add immediate actions here if needed when the div appears

      console.log(
        "Starting new observer to watch INSIDE the added .delivery-details."
      );
      // Start the second observer to watch *inside* the newly found div
      detailsObserver.observe(deliveryDetailsNode, detailsObserverConfig);
    } else {
      console.log(
        "... .delivery-details was not among the added nodes this time."
      );
    }
  };

  // Configuration for observing .card-information (simpler)
  const parentObserverConfig = {
    childList: true, // We only care if direct children are added/removed
    // subtree: false // Not needed for watching direct children additions
  };

  // Create the observer instance for the parent
  const parentObserver = new MutationObserver(handleParentMutations);

  // --- Start Observing ---
  if (parentNodeToObserve) {
    console.log("Setting up initial observer on .card-information.");
    parentObserver.observe(parentNodeToObserve, parentObserverConfig);
    console.log(
      "Observer is now watching .card-information for the addition of .delivery-details."
    );

    // Optional: Check if .delivery-details might *already* be there when the script runs
    const existingDetails =
      parentNodeToObserve.querySelector(".delivery-details");
    if (existingDetails) {
      console.log(
        ".delivery-details already exists on initial check. Starting detailsObserver immediately."
      );
      parentObserver.disconnect(); // No need to watch the parent
      detailsObserver.observe(existingDetails, detailsObserverConfig);
    }
  } else {
    console.log(
      "Cannot start observer: Parent node (.card-information) not found."
    );
  }
  //#####################################################

  $("body").on("click", ".card-colors .color", function(e){
    $(this).parent().find(".color").removeClass("active");
    $(this).addClass("active");
  });
});

jQuery('quantity-input input[id^="quantity-"]').change(function (e) {
  //updateActiveBulkBox(jQuery(this).val());
});


document.addEventListener('DOMContentLoaded', function() {
  const stickyElement = document.querySelector('.sections-brand-slider');
  if (!stickyElement) return;

  // Create sentinel element
  const sentinel = document.createElement('div');
  sentinel.style.cssText = `
    height: 1px;
    width: 100%;
    visibility: hidden;
    pointer-events: none;
    margin: 0;
    padding: 0;
    display:block;
  `;

  // Insert sentinel before the sticky element
  stickyElement.parentNode.insertBefore(sentinel, stickyElement);

  // Create Intersection Observer
  const observer = new IntersectionObserver(entries => {
    const entry = entries[0];
    
    if (entry.intersectionRatio === 0) {
      // Sentinel completely out of viewport
      if (entry.boundingClientRect.top < 0) {
        stickyElement.classList.add('is_sticky');
      } else {
        stickyElement.classList.remove('is_sticky');
      }
    } 
    else if (entry.intersectionRatio === 1) {
      // Sentinel completely in viewport
      stickyElement.classList.remove('is_sticky');
    }
  }, {
    threshold: [0, 1]
  });

  // Start observing
  observer.observe(sentinel);

  // Cleanup on element removal (optional)
  const cleanup = () => {
    if (document.body.contains(sentinel)) {
      observer.unobserve(sentinel);
      sentinel.remove();
    }
  };
  
  // Example cleanup (if using modern frameworks)
  if (typeof MutationObserver !== 'undefined') {
    const mo = new MutationObserver(() => {
      if (!document.body.contains(stickyElement)) cleanup();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  Array.from(document.getElementsByClassName('stocka-color-picker')).forEach(pickerEl => {
    pickerEl.addEventListener('click', function () {
      const picker = new ColorPicker(this, {
        headless: true
      });
      picker.open();
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  if (!document.body.classList.contains('template-collection')) return;

  // Same SVG paths as ensureSearchanizePaginationArrows in searchanize.js
  // CSS rotation (rotate 180deg in LTR) is handled in custom.css, mirroring snize
  const nextSVG = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M12.5 4.25 6.75 10l5.75 5.75" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path></svg>';
  const prevSVG = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="m7.5 4.25 5.75 5.75-5.75 5.75" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path></svg>';

  document.querySelectorAll('.pagination__item--next').forEach(function (el) {
    el.innerHTML = nextSVG;
  });
  document.querySelectorAll('.pagination__item--prev').forEach(function (el) {
    el.innerHTML = prevSVG;
  });
});
